/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { createAction } from '../../utils/redux-utils';
import { StoresListDto, StoresListFilterParams } from '../api/stores/storesClientTypings';
import { Notification, NOTIFICATION_TYPES } from '../../utils/utils';
import { i18n } from '../translation/i18n';

export enum StoresActionType {
    OPEN_REGISTRY_STORES_LIST_PAGE = 'RegistryStoresList/ open page',
    EXIT_REGISTRY_STORES_LIST_PAGE = 'RegistryStoresList/ exit page',

    FETCH_NEXT_PAGE_START = 'RegistryStoresList/ fetch next page',
    APPLY_FILTERS = 'RegistryStoresList/ apply filters',

    CHANGE_FILTERS = 'RegistryStoresList/ change filters',

    DOWNLOAD_EXCEL = 'RegistryStoresList/ download stores list as excel',
    DOWNLOAD_EXCEL_SUCCESS = 'RegistryStoresList/ download stores list as excel success',
    DOWNLOAD_EXCEL_ERROR = 'RegistryStoresList/ download stores list as excel error',

    FETCH_STORES_LIST_SUCCESS = 'RegistryStoresList/ fetch stores list success',
    FETCH_STORES_LIST_ERROR = 'RegistryStoresList/ fetch stores list error',
}

export const openRegistryStoresListAction = () => createAction(StoresActionType.OPEN_REGISTRY_STORES_LIST_PAGE);

export const exitRegistryStoresListAction = () => createAction(StoresActionType.EXIT_REGISTRY_STORES_LIST_PAGE);

export const fetchNextPageStartAction = () => createAction(StoresActionType.FETCH_NEXT_PAGE_START);

export const applyFilteringAction = () => createAction(StoresActionType.APPLY_FILTERS);

export const changeFiltersAction = (params: StoresListFilterParams) =>
    createAction(StoresActionType.CHANGE_FILTERS, params);

export const downloadStoresListAsExcelAction = () => createAction(StoresActionType.DOWNLOAD_EXCEL);

export const downloadStoresListAsExcelSuccessAction = () =>
    createAction(StoresActionType.DOWNLOAD_EXCEL_SUCCESS, {
        notification: {
            type: NOTIFICATION_TYPES[1],
            message: i18n.t('downloadings.fileCreationRequestAccepted'),
        },
    });

export const downloadStoresListAsExcelErrorAction = (notification: Notification) =>
    createAction(StoresActionType.DOWNLOAD_EXCEL_ERROR, { notification });

export const fetchStoresListSuccessAction = (list: StoresListDto) =>
    createAction(StoresActionType.FETCH_STORES_LIST_SUCCESS, {
        list,
        notification:
            list.stores.length === 0
                ? {
                      type: NOTIFICATION_TYPES[1],
                      message: i18n.t('errors.notFoundByParams'),
                  }
                : null,
    });

export const fetchStoresListErrorAction = (notification: Notification) =>
    createAction(StoresActionType.FETCH_STORES_LIST_ERROR, { notification });

export type StoresActions =
    | ReturnType<typeof openRegistryStoresListAction>
    | ReturnType<typeof exitRegistryStoresListAction>
    | ReturnType<typeof fetchNextPageStartAction>
    | ReturnType<typeof applyFilteringAction>
    | ReturnType<typeof changeFiltersAction>
    | ReturnType<typeof downloadStoresListAsExcelAction>
    | ReturnType<typeof downloadStoresListAsExcelSuccessAction>
    | ReturnType<typeof downloadStoresListAsExcelErrorAction>
    | ReturnType<typeof fetchStoresListSuccessAction>
    | ReturnType<typeof fetchStoresListErrorAction>;
